import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Textarea } from '../../components/ui/textarea';
import { Label } from '../../components/ui/label';
import { Copy, Save } from 'lucide-react';
import { COMPANY } from '../../config/company';

const SaveTemplateModal = ({
  language,
  showModal,
  setShowModal,
  templateName,
  setTemplateName,
  templateDescription,
  setTemplateDescription,
  saveAsTemplate,
  savingTemplate
}) => {
  if (!showModal) return null;
  
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader style={{ backgroundColor: COMPANY.primaryColor }} className="text-white rounded-t-lg">
          <CardTitle className="flex items-center">
            <Copy className="mr-2 h-5 w-5" />
            {language === 'es' ? 'Guardar como Plantilla' : 'Save as Template'}
          </CardTitle>
        </CardHeader>
        <CardContent className="p-6 space-y-4">
          <p className="text-sm text-gray-600">
            {language === 'es' 
              ? 'Esta plantilla guardará todos los artículos de línea, tarifas generales y términos de este presupuesto para uso futuro.'
              : 'This template will save all line items, general fees, and terms from this estimate for future use.'
            }
          </p>
          <div>
            <Label>{language === 'es' ? 'Nombre de la Plantilla' : 'Template Name'} *</Label>
            <Input
              value={templateName}
              onChange={(e) => setTemplateName(e.target.value)}
              placeholder={language === 'es' ? 'Ej: Reemplazo de Techo de Teja' : 'e.g., Tile Roof Replacement'}
              data-testid="template-name-input"
            />
          </div>
          <div>
            <Label>{language === 'es' ? 'Descripción (Opcional)' : 'Description (Optional)'}</Label>
            <Textarea
              value={templateDescription}
              onChange={(e) => setTemplateDescription(e.target.value)}
              placeholder={language === 'es' ? 'Breve descripción de cuándo usar esta plantilla' : 'Brief description of when to use this template'}
              rows={3}
            />
          </div>
          <div className="flex gap-3 pt-4">
            <Button 
              variant="outline" 
              className="flex-1"
              onClick={() => {
                setShowModal(false);
                setTemplateName('');
                setTemplateDescription('');
              }}
            >
              {language === 'es' ? 'Cancelar' : 'Cancel'}
            </Button>
            <Button 
              className="flex-1 text-white"
              style={{ backgroundColor: COMPANY.primaryColor }}
              onClick={saveAsTemplate}
              disabled={savingTemplate || !templateName.trim()}
              data-testid="save-template-btn"
            >
              <Save className="mr-2 h-4 w-4" />
              {savingTemplate ? '...' : (language === 'es' ? 'Guardar Plantilla' : 'Save Template')}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SaveTemplateModal;
